
import React from 'react'
const withToggle = (WrappedComponent, togglableVariables, defaultValues) => {
  class Togglable extends React.Component {
    constructor (props) {
      super(props)
      this.state = Object.values(togglableVariables)
        .reduce((acc, key, index) => (
          Object.assign(acc, { [key]: defaultValues[index] })),
        {})
    }
    toggleValue = (variable) => { this.setState({ [variable]: !this.state[variable] }) }
    render () {
      return <WrappedComponent {...this.props} {...this.state} toggleValue={this.toggleValue} />
    }
  }

  return Togglable
}

export default withToggle
